import CalculatorIcon from './CalculatorIcon';

export default CalculatorIcon;
